/* global window */
import React from 'react';
import {
  CheckOutlined,
  StockOutlined,
  TeamOutlined,
  DashboardOutlined,
  SettingOutlined,
  PoweroffOutlined,
  InfoCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  CopyOutlined,
  CarOutlined,
  UploadOutlined,
  BarcodeOutlined
} from '@ant-design/icons';
import { Layout, Menu, Row, Col, Space, Button, Popover } from 'antd';
import LogoSmall from '../../static/logo-small.png';
import logo from 'src/static/logo-white.svg';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import GWMLogo from '../../static/Haval-and-GMW.png';
import styled from 'styled-components';
import { Cookies } from 'react-cookie';
import { getSidebarCollapsed } from 'src/redux/selectors';
import { collapseSidebar } from 'src/redux/actions/status';
import { MenuItem } from 'rc-menu';

const { SubMenu } = Menu;

const StyledLink = styled(Link)`
  font-size: 15px;
  color: white !important;
  :hover {
    text-decoration: none !important;
  }
  .anticon svg {
    display: inline-block;
    font-size: 20px !important;
    color: black !important;
  }
`;

const { Sider } = Layout;

const Sidebar = props => {
  const signOut = () => {
    if (window.cordova) {
      window.FirebasePlugin.getToken(
        token => {
          window.pubnub.push.deleteDevice(
            {
              device: token,
              pushGateway: 'gcm' // apns, gcm, mpns
            },
            function(status) {
              if (status.error) {
                console.log('operation failed w/ error:', status);
              }
            }
          );
        },
        error => {
          console.error(error);
        }
      );
    }

    const cookies = new Cookies();
    cookies.remove('token');
    cookies.remove('basic');
    localStorage.clear();
    window.location.reload();
  };

  return (
    <Sider
      collapsedWidth="90"
      trigger={null}
      collapsible
      collapsed={props.collapsed}
      width={210}
      style={{
        //height: "calc(100vh - 50px)",
        //marginTop: "50px",
        // border: '1px solid #F917003b',
        //zIndex: 9,
        //position: 'fixed',
        background: 'white',
        textAlign: 'center'
        //height: 'calc(100vh - 40px)',
        //left: 0,
        //top: 40
      }}
    >
      <img
        onClick={props.collapseSidebar}
        src={props.collapsed ? LogoSmall : LogoSmall}
        alt="Logo"
        style={{
          width: props.collapsed ? '90%' : '90%',
          marginTop: 5,
          marginLeft: props.collapsed ? '' : ''
        }}
      />
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['stock']}
        style={{ background: 'transparent', marginTop: '3vh' }}
      >
        {/*<Menu.Item
          onClick={props.collapsed ? null : props.collapseSidebar}
          key='dashboard'
          icon={
            <DashboardOutlined style={{ fontSize: "20px", color: "black" }} />
          }
        >
          <StyledLink to='/admin/dashboard'>
            <span>Dashboard</span>
          </StyledLink>
        </Menu.Item>*/}
        {/*<Menu.Item
          onClick={props.collapsed ? null : props.collapseSidebar}
          key='usermanagement'
          icon={<TeamOutlined style={{ fontSize: "20px", color: "black" }} />}
        >
          <StyledLink to='/admin/users'>
            <span>User Management</span>
          </StyledLink>
        </Menu.Item>*/}
        <Menu.Item
          onClick={props.collapsed ? null : props.collapseSidebar}
          key="stock"
          icon={<CarOutlined style={{ fontSize: '20px', color: 'black' }} />}
        >
          <StyledLink to="/admin/stock">
            <span>Vehicle Management</span>
          </StyledLink>
        </Menu.Item>
        <Menu.Item
          onClick={props.collapsed ? null : props.collapseSidebar}
          key="pexunits"
          icon={<CopyOutlined style={{ fontSize: '20px', color: 'black' }} />}
        >
          <StyledLink to="/user/pexunit">
            <span>Website Management</span>
          </StyledLink>
        </Menu.Item>
        <SubMenu
          key="sub1"
          title={
            <span>
              <BarcodeOutlined style={{ fontSize: '20px', color: 'black' }} />
              <span style={{ fontSize: '15px', color: 'black' }}>
                Specials/Accessories
              </span>
            </span>
          }
        >
          <Menu.Item
            onClick={props.collapsed ? null : props.collapseSidebar}
            key="pexrequest"
            icon={
              <img
                src={GWMLogo}
                style={{
                  width: '60px'
                  // marginTop: 5,
                  // marginLeft: props.collapsed ? "" : "",
                }}
              />
            }
          >
            <StyledLink to="/user/pexrequests">
              <span style={{ color: 'white' }}>
                GWM/Haval Specials Management
              </span>
            </StyledLink>
          </Menu.Item>
          <Menu.Item
            onClick={props.collapsed ? null : props.collapseSidebar}
            key="request"
            icon={
              <img
                src={GWMLogo}
                style={{
                  width: '60px'
                  // marginTop: 5,
                  // marginLeft: props.collapsed ? "" : "",
                }}
              />
            }
          >
            <StyledLink to="/user/requests">
              <span style={{ color: 'white' }}>
                GWM/Haval Accessories Management
              </span>
            </StyledLink>
          </Menu.Item>
        </SubMenu>
        {/*<Menu.Item
          icon={
            <SettingOutlined style={{ fontSize: '20px', color: 'black' }} />
          }
          key="settings"
          style={{
            position: 'absolute',
            bottom: 60,
            width: props.collapsed ? 90 : 210
          }}
        >
          <StyledLink to="/admin/dashboard">
            <span>Settings</span>
          </StyledLink>
        </Menu.Item>*/}
      </Menu>
    </Sider>
  );
};

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state)
  };
};

const mapDispatchToProps = {
  collapseSidebar
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar)
);
